import { InfiniteTable } from '@vrplatform/table';
import { Group } from '@mantine/core';
import type { ReactNode } from 'react';
import { useAuditEffectsTableFilter } from './useAuditEffectsTableFilter';
import { AuditEffectsTableFilter } from './AuditEffectsTableFilter';
import type { useAuditEffectsTableQuery } from './useAuditEffectsTableQuery';
import { useAuditEffectsTableColumns } from './useAuditEffectsTableColumns';

type Props = {
  queryData: ReturnType<typeof useAuditEffectsTableQuery>;
  children?: ({ disabled }: { disabled: boolean }) => ReactNode;
};

export const AuditEffectsTable = ({ queryData, children }: Props) => {
  'use memo';

  const { reset: resetFilter } = useAuditEffectsTableFilter();

  const columns = useAuditEffectsTableColumns();

  return (
    <InfiniteTable
      queryData={queryData}
      columns={columns}
      virtualization={{
        enableRowVirtualization: true,
        overscan: 30,
      }}
      resetFilter={resetFilter}
    >
      <Group justify="space-between" w="100%" wrap="nowrap">
        <AuditEffectsTableFilter />
        {children?.({ disabled: !queryData?.data?.pages?.[0]?.list.length })}
      </Group>
    </InfiniteTable>
  );
};
